import { NSARouterMakerResult } from "namirasoft-account-react";
import { AlarmProps } from "../AlarmProps";
import { AlarmLayout } from "../AlarmLayout";
import { AlarmEntities } from "../AlarmEntities";

export interface AlarmViewPageProps extends NSARouterMakerResult, AlarmProps
{ }

function AlarmViewPage(props: AlarmViewPageProps)
{
    return (
        <AlarmLayout {...props}
            action={{
                title: "",
                description: "Detailed information about each alarm you've created.",
                menus: {}
            }}
            pages={{
                entity: AlarmEntities.alarm(props),
                view: {}
            }}
        >
            <></>
        </AlarmLayout >
    );
}

export default AlarmViewPage;